import { render, staticRenderFns } from "./ReferHoverTip2.vue?vue&type=template&id=0e8755b1&scoped=true"
import script from "./ReferHoverTip2.vue?vue&type=script&lang=js"
export * from "./ReferHoverTip2.vue?vue&type=script&lang=js"
import style0 from "./ReferHoverTip2.vue?vue&type=style&index=0&id=0e8755b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8755b1",
  null
  
)

export default component.exports